import { TicketController as controller } from './ticket.controller';
import { template } from './ticket.roles';

export const ticketComponent = {
  name: 'ticketComponent',
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<'
  }
};
